export const removeDuplicates = <T extends object>(
  items: T[],
  uniqueByKeys: (keyof T)[],
): T[] => {
  return items.filter((item, index, list) => {
    const firstSameItemIndex = list.findIndex(listItem =>
      uniqueByKeys.every(key => listItem[key] === item[key]),
    )

    return firstSameItemIndex === index
  })
}
